import Property from './Property'

export default class ValueProperty extends Property {
  constructor (name, type, value, children, parent) {
    super(name, type, children, parent)
    this.value = value
  }
}
